/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const StaffGradedCircledIcon = /*#__PURE__*/ createSvgIcon(
  'StaffGradedCircledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <circle cx={10} cy={10} r={10} fill="#E8EEF7" />
            <path
              d="M10 11.5c.344 0 .638-.122.883-.367s.367-.54.367-.883c0-.344-.122-.638-.367-.883A1.204 1.204 0 0010 9c-.344 0-.638.122-.883.367s-.367.54-.367.883c0 .344.122.638.367.883s.54.367.883.367zM7.5 14h5v-.36a1.245 1.245 0 00-.766-1.156 4.719 4.719 0 00-.836-.265 4.197 4.197 0 00-.898-.094c-.313 0-.612.031-.898.094a4.717 4.717 0 00-.836.265 1.245 1.245 0 00-.766 1.157V14zm6.25 2.5h-7.5c-.344 0-.638-.122-.883-.367A1.204 1.204 0 015 15.25v-10c0-.344.122-.638.367-.883S5.907 4 6.25 4h4.484a1.234 1.234 0 01.875.36l3.032 3.03a1.232 1.232 0 01.36.875v6.985c-.001.344-.123.638-.368.883a1.204 1.204 0 01-.883.367zm0-1.25V8.281L10.719 5.25H6.25v10h7.5z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default StaffGradedCircledIcon;
